import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { transformar } from "@/lib/trato";

// Adapta TODO el texto fijo de la plataforma a la variante de trato de la empresa.
// Si variante === "tu", recorre los nodos de texto y algunos atributos y aplica voseo -> tuteo.
// Solo edita valores de texto/atributos (nunca agrega/quita nodos) => seguro con React.
// El diccionario es idempotente (solo matchea formas voseo), así que reejecutar no rompe nada.

const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "INPUT", "SELECT", "OPTION"]);
const ATTRS = ["placeholder", "title", "aria-label", "alt"];

function debeSaltar(el) {
  if (!el) return true;
  if (SKIP_TAGS.has(el.nodeName)) return true;
  if (el.isContentEditable) return true;
  if (el.closest && el.closest("[data-no-trato]")) return true;
  return false;
}

function recorrer(root) {
  if (!root || !root.querySelectorAll) return;
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      if (debeSaltar(node.parentElement)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const nodes = [];
  let n;
  while ((n = tw.nextNode())) nodes.push(n);
  for (const node of nodes) {
    const nv = transformar(node.nodeValue);
    if (nv !== node.nodeValue) node.nodeValue = nv;
  }
  root.querySelectorAll("[placeholder],[title],[aria-label],[alt]").forEach((el) => {
    if (el.closest && el.closest("[data-no-trato]")) return;
    ATTRS.forEach((a) => {
      const v = el.getAttribute(a);
      if (v) {
        const nv = transformar(v);
        if (nv !== v) el.setAttribute(a, nv);
      }
    });
  });
}

export default function TratoAdaptador() {
  const { empresa } = useAuth();
  const variante = empresa?.variante || "vos";

  useEffect(() => {
    if (variante !== "tu") return;
    let raf = null;
    const observer = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(run);
    });
    function run() {
      observer.disconnect();
      try {
        recorrer(document.body);
      } catch (e) {
        /* noop */
      }
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ATTRS,
      });
    }
    run();
    return () => {
      if (raf) cancelAnimationFrame(raf);
      observer.disconnect();
    };
  }, [variante]);

  return null;
}
